import { LoadableFactory } from '®shared/data';

import {
  PageContentActionTypes,
  PageContentActions,
} from './page-content.actions';
import { PageContentState } from './page-content.state';

export function pageContentReducer(
  state: PageContentState,
  action: PageContentActions,
): PageContentState {
  switch (action.type) {
    case PageContentActionTypes.FETCH_PAGE_CONTENT: {
      const { pageId } = action.payload;
      return {
        ...state,
        [pageId]: LoadableFactory.loading(),
      };
    }
    case PageContentActionTypes.FETCH_PAGE_CONTENT_SUCCESS: {
      const { pageId, pageContent } = action.payload;
      return {
        ...state,
        [pageId]: LoadableFactory.loaded(pageContent),
      };
    }
    case PageContentActionTypes.FETCH_PAGE_CONTENT_FAILED: {
      const { pageId, error } = action.payload;
      return {
        ...state,
        [pageId]: LoadableFactory.errored(error),
      };
    }
    default: {
      return state;
    }
  }
}
